import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { offboarding } from "../../modules/offboarding";

declare var ko: any;

export class jobApplicationsView_template extends vnTemplate{

    protected getTemplateHtml(): string{

        return `

                <div class="w-text">
                    <div id="myModal" data-bind="if: !isStatusResolved() && isCandidate() && status().id < 4">
                        <p class="text emp">Below, you will find your application for a position with us.  In order to be considered, please click through the <a class="icon i-edit " data-bind="event: { click: onClickEdit }"> Edit Application</a> button in order to follow any required instructions and submit your application.</p>
                    </div>  
                    
                    <div class="profile-desc" data-bind="if: additionalText() && isCandidate()">
                        <div>
                        <p class="text-title"> Description </p>
                        <input type="checkbox" id="expend_1" class="expend-input">
                        <label for="expend_1" class="expend-label">see all</label>
                        <div class="rich-text text emp text-list column expend" style="padding: 2rem" data-bind="html: additionalText"></div>
                    </div>

                </div>
                </div>
                
                <div class="w-form-2-column">
                
                    <div class="w-form w-form-large">
                    
                        <div class="form-header">
                            <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button> 
                            <h3 class="form-title" data-bind="text: positionTitle, css: brandIcon"></h3>
                            <span></span>                       
                        </div>
                        
                        <div class="form-pagination" data-bind="visible: !isCandidate()">
                            <button class="btn icon" type="button" data-bind="event:{click: onClickTab.bind($data, 'application')}, css: { 'is-activated' : selectedTab() == 'application'}">Application</button>
                            <button class="btn icon nbr" type="button" data-bind="event:{click: onClickTab.bind($data, 'internalNotes')}, css: { 'is-activated' : selectedTab() == 'internalNotes'}">Internal Notes<span data-bind="visible: (internalNotes().length + applicationHistory().length + offboardingHistory().length) > 0, text: internalNotes().length + applicationHistory().length + offboardingHistory().length"></span></button>
                        </div>
                        
                        <div class="w-tabs-content" data-bind="css: { 'is-showing' : selectedTab() == 'application'}"> 
                        
                            <div class="w-form-body header" >

                                <div class="header-bg" data-bind="style:{backgroundImage: 'url(' + jobProfileImageUrl() + ')'}"></div>

                                <div class="form-body">
                                    <div class="form-group">
                                        <label for="" class="form-label">candidate name</label>                                
                                        <div style="display: flex;flex-direction: row" >
                                            <span class="form-view-text" data-bind="text: candidateName"></span>
                                            <!-- ko if: permissions()['users_list'].write -->
                                            <div style="margin-left: 1rem">
                                                <a data-bind="attr:{href: candidateProfileLink()}" target="_blank" class="btn border only-icon icon i-go-to"></a><span class="hide-text"></span></a>
                                            </div>
                                            <!-- /ko -->
                                        </div>
                                    </div>
                                     <div class="form-group">
                                        <label for="" class="form-label">candidate email</label>
                                        <span class="form-view-text" style="text-transform: lowercase;" data-bind="text: candidateEmail"></span>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="form-label">position title</label>
                                        <div style="display: flex;flex-direction: row" >
                                            <span class="form-view-text" data-bind="text: positionTitle"></span>
                                            <!-- ko if: permissions()['job_profiles'].write -->
                                            <div data-bind="if: !isCandidate()" style="margin-left: 1rem">
                                                <a data-bind="attr:{href: jobProfileViewLink()}" target="_blank" class="btn border only-icon icon i-go-to"></a><span class="hide-text"></span></a>
                                            </div>
                                            <!-- /ko -->
                                        </div>
                                    </div>
                                
                                </div>
                                <div class="form-body">
                                     <div class="form-group">
                                        <label for="" class="form-label">user role</label>
                                        <span class="form-view-text" data-bind="text: userRoles"></span>
                                    </div>
                                     <div class="form-group">
                                        <label for="" class="form-label">country</label>
                                        <span class="form-view-text" data-bind="text: country"></span>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="form-label">user brands</label>
                                        <ul class="brand-list" data-bind="foreach: userBrands">
                                            <li class="brand-item full-icon" data-bind="css: iconImage"></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- ko if: (resume() &&  resume().id > 1 ) || (coverLetter() && coverLetter().id > 1) -->
                            <div class="w-form-body section">                                
                                <div class="form-body">
                                    <div class="w-step">
                                        <div class="step" data-bind="if: stepsDetails()['files']">
                                            <span class="step-num" data-bind="text: stepsDetails()['files'].current"></span>
                                            <div class="w-info">
                                                <span class="step-title">application files</span>
                                            </div>
                                            <span data-bind="css : { 'step-check icon i-check is-visible' : (stepsDetails()['files'].completed >= stepsDetails()['files'].required)}"></span>
                                        </div>
                                    </div>
                                    <div class="form-group" data-bind="if: resume() && resume().id > 1">
                                        <span class="sub-title">Resume<span data-bind="visible: resume().id == 2 || resume().id == 3" class="form-required">* required</span></span>
                                        <div data-bind="if: resumeFile()">
                                            <div class="w-entry" > 
                                                <span id="resume" class="icon" data-bind="text: resumeFile().name"></span>    
                                                <div class="w-btn">  
                                                     <a class="btn only-icon border icon i-view" data-bind="hidden: (resumeFile().extension == 'rtf' || resumeFile().extension == 'doc' || resumeFile().extension == 'docx'), attr: { href: resumeFile().path}" type="button" target="_blank"></a>
                                                     <button class="btn only-icon border icon i-download" data-bind="event: { click: onClickDownloadFile.bind($data, resumeFile().path, resumeFile().name) }" type="button"></button>                          
                                                </div>   
                                            </div> 
                                        </div>
                                        <div class="w-entry" data-bind="visible: !resumeFile()"><span>No File Uploaded</span></div>                                
                                    </div>
                                </div>
                                <div class="form-body"> 
                                    <div class="form-group" data-bind="if: coverLetter() && coverLetter().id > 1">
                                        <span class="sub-title">Cover Letter<span data-bind="visible: coverLetter().id == 2 || coverLetter().id == 3" class="form-required">* required</span></span>
                                        <div data-bind="if: coverLetterFile()">
                                            <div class="w-entry"> 
                                                <span id="coverLetter" class="icon"data-bind="text: coverLetterFile().name"></span>    
                                                <div class="w-btn">  
                                                     <a class="btn only-icon border icon i-view" data-bind="hidden: (coverLetterFile().extension == 'rtf' || coverLetterFile().extension == 'doc' || coverLetterFile().extension == 'docx'), attr: { href: coverLetterFile().path}" type="button" target="_blank"></a>
                                                     <button class="btn only-icon border icon i-download" data-bind="event: { click: onClickDownloadFile.bind($data, coverLetterFile().path, coverLetterFile().name) }" type="button"></button>                          
                                                </div>   
                                            </div>
                                        </div>
                                        <div class="w-entry" data-bind="visible: !coverLetterFile()"><span>No File Uploaded</span></div>                                    
                                    </div>
                                </div>
                            </div>
                            <!-- /ko -->     
                                    
                            <!-- ko if: referentialWork() && referentialWork().id > 1 -->
                            <div class="w-form-body section">                                
                                <div class="form-body full-width">
                                    <div class="w-step">
                                        <div class="step" data-bind="if: stepsDetails()['referentialWork']">
                                            <span class="step-num" data-bind="text: stepsDetails()['referentialWork'].current"></span>
                                            <div class="w-info">
                                                <span class="step-title">Referential work</span>
                                            </div>
                                            <span data-bind="css : { 'step-check icon i-check is-visible' : (stepsDetails()['referentialWork'].completed >= stepsDetails()['referentialWork'].required)}"></span>
                                        </div>
                                    </div>
                                    
                                    <div class="form-group" data-bind="if: referentialWork().instructions">
                                        <span class="sub-title">Instructions</span>
                                        <div class="step-instruction rich-text" data-bind="html: referentialWork().instructions"></div>
                                    </div>
                                   
                                    <div class="form-group referential-work-view">
                                        <div class="w-entry w-link" data-bind="visible: referentialWork().links && referentialWork().links.length > 0, foreach: referentialWork().links"> 
                                            <label data-bind="attr: { for: 'link' + $index()}" class="form-label">Link<span data-bind="visible: $parent.referentialWork().id == 2 || $parent.referentialWork().id == 3" class="form-required">* required</span></label>
                                            <a class="no-cap icon i-link" data-bind="attr: { href: $data}, text: $data, visible: $data !='' " target="_blank"></a>           
                                        </div> 
                                        <div class="w-entry w-link" data-bind="visible: !referentialWork().links || (referentialWork().links && referentialWork().links.length == 0)"> 
                                            <span>No Links Added</span>          
                                        </div>                                 
                                    </div>
                                    
                                </div>
                            </div>
                            <!-- /ko -->
                            
                            <!-- ko if: writtenSample() &&  writtenSample().id > 1 || writtenSampleText()-->
                            <div class="w-form-body section">                                
                                <div class="form-body full-width">
                                    <div class="w-step">
                                        <div class="step" data-bind="if: stepsDetails()['writtenSample']">
                                            <span class="step-num" data-bind="text: stepsDetails()['writtenSample'].current"></span>
                                            <div class="w-info">
                                                <span class="step-title">written sample</span>
                                            </div>
                                            <span data-bind="css : { 'step-check icon i-check is-visible' : (stepsDetails()['writtenSample'].completed >= stepsDetails()['writtenSample'].required)}"></span>
                                        </div>
                                        
                                    </div>
                                    
                                    <div class="form-group " data-bind="if: writtenSample() && writtenSample().id > 1 && writtenSample().instructions">
                                        <span class="sub-title">Instructions</span>

                                        <div class="step-instruction" data-bind="html: writtenSample().instructions"></div>

                                    </div>
                                   
                                   <div class="form-group rich-text-bg" data-bind="if: writtenSampleText()">
                                        <span class="form-required" data-bind="if: writtenSample().id == 2 || writtenSample().id == 3">* required</span>
                                        <div class="form-text max-width rich-text" id="writtenSampleText" data-bind="html: writtenSampleText"></div>
                                    </div>
                                    
                                    <div class="form-group" data-bind="if: writtenSampleFile() && !writtenSampleText()">
                                       <div class="w-entry" data-bind="if: writtenSampleFile()"> 
                                            <span id="writtenSample" class="icon" data-bind="text: writtenSampleFile().name"></span>
                                            <div class="w-btn">
                                                <a class="btn only-icon border icon i-view" data-bind="hidden: (writtenSampleFile().extension == 'rtf' || writtenSampleFile().extension == 'doc' || writtenSampleFile().extension == 'docx'), attr: { href: writtenSampleFile().path}" type="button" target="_blank"></a>
                                                <button class="btn only-icon border icon i-download" data-bind="event: { click: onClickDownloadFile.bind($data, writtenSampleFile().path, writtenSampleFile().name) }" type="button"></button>
                                            </div>
                                       </div>
                                    </div>
                                    
                                    <div class="form-group w-entry" data-bind="visible: !writtenSampleFile() && !writtenSampleText()">
                                        <span>No File Uploaded</span>
                                    </div>
                                </div>
                            </div>
                            <!-- /ko -->
                            
                            <!-- ko if: imageSample() && imageSample().id > 1-->
                            <div class="w-form-body section">                                
                                <div class="form-body full-width">
                                    <div class="w-step">
                                        <div class="step" data-bind="if: stepsDetails()['imageSample']">
                                            <span class="step-num" data-bind="text: stepsDetails()['imageSample'].current"></span>
                                            <div class="w-info">
                                                <span class="step-title">image sample</span>
                                            </div>
                                            <span data-bind="css : { 'step-check icon i-check is-visible' : (stepsDetails()['imageSample'].completed >= stepsDetails()['imageSample'].required)}"></span>
                                        </div>
                                    </div>
                                    
                                    <div class="form-group" data-bind="if: imageSample().instructions">
                                        <span class="sub-title">Instructions</span>
                                        <div class="step-instruction" data-bind="html: imageSample().instructions"></div>

                                    </div>
                                   
                                    <div class="form-group image-sample" data-bind="foreach : imageSampleFiles">
                                        <span data-bind="if: $parent.imageSample().id == 2 || $parent.imageSample().id == 3" class="form-required">* required</span>
                                        <div class="w-entry">
                                            <span data-bind="attr: {id : 'imageSample' + $index()}, text: name" class="icon"></span>
                                            <div class="w-btn">
                                                <a class="btn only-icon border icon i-view" data-bind="hidden: (extension == 'rtf' || extension == 'doc' || extension == 'docx'), attr: { href: path}" type="button" target="_blank"></a>
                                                <button class="btn only-icon border icon i-download" data-bind="event: { click: $parent.onClickDownloadFile.bind($data, path, name) }" type="button"></button>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    <div class="form-group w-entry" data-bind="visible:imageSampleFiles().length == 0"><span>No File Uploaded</span></div> 
                                    
                                </div>
                            </div>
                            <!-- /ko -->
                            
                            <!-- ko if: answers() && answers().length > 0 -->
                            <div class="w-form-body section">                                
                                <div class="form-body full-width">
                                    <div class="w-step ">
                                        <div class="step" data-bind="if: stepsDetails()['answers']">
                                            <span class="step-num" data-bind="text: stepsDetails()['answers'].current"></span>
                                            <div class="w-info">
                                                <span class="step-title">Questions</span>
                                            </div>
                                            <span data-bind="css : { 'step-check icon i-check is-visible' : (stepsDetails()['answers'].completed == stepsDetails()['answers'].required)}"></span>
                                        </div>
                                    </div>
                                   
                                   <div class="form-group">
                                        <ul class="question-list" data-bind="foreach: answers">
                                            <li class="question-item">
                                                <div class="step-question">
                                                    <p class="comment" data-bind="html: question"> </p><span data-bind="visible: id == 2 || id == 3" class="required"> * required</span>
                                                </div>
                                                <div class="step-answer">
                                                    <p class="w-entry" data-bind="visible: answer != '', text: answer"> </p>
                                                    <p class="w-entry" data-bind="visible: answer == ''">No Answer </p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <!-- /ko -->
                        </div>
                        
                        <div class="w-tabs-content" data-bind="css: { 'is-showing' : selectedTab() == 'internalNotes' && !isCandidate()}"> 
                            
                            <div class="form-body section internal-notes" id="internal-notes">
                                <div class="form-body">
                                    <div class="form-group form-comment">
                                        <div class="history-cards">
                                            <a class="card total-history no-hover">
                                                <h2>Total<br>Internal Notes</h2>
                                                <span class="count" data-bind="text: applicationHistory().length + offboardingHistory().length + internalNotes().length"></span>
                                            </a>
                                            <button class="card app-history" data-bind="click: () => scrollToSection('application-history-section')">
                                                <span class="icon i-samples"></span>
                                                <span class="count" data-bind="text: applicationHistory().length"></span>
                                                <h2>Application<br>History</h2>
                                            </button>
                                            <button class="card brand-history" data-bind="click: () => scrollToSection('brand-access-notes-section')">
                                                <span class="icon i-brand"></span>
                                                <span class="count" data-bind="text: offboardingHistory().length"></span>
                                                <h2>Brand<br>Access Notes</h2>
                                            </button>
                                            <button class="card internal-notes" data-bind="click: () => scrollToSection('internal-comments-section')">
                                                <span class="icon i-notes"></span>
                                                <span class="count" data-bind="text: internalNotes().length"></span>
                                                <h2>Internal<br>Comments</h2>
                                            </button>
                                        </div>
                                    </div>                                

                                    <div class="form-group form-comment" id="application-history-section">
                                       <h3 class="form-sub-title no-margin icon i-samples app-history">Application History</h3>
                                    </div>
                                    <div class="form-group">
                                        <div class="w-list-results">
                                            <!-- ko if: applicationHistory().length > 0 -->
                                            <table class="list-results">
                                                <thead>
                                                    <tr>
                                                        <th><span>Position</span></th>
                                                        <th class="time-width"><span>Application <br> Status</span></th>
                                                        <th class="time-width"><span>Steps <br> Completed</span></th>
                                                        <th class="time-width"><span>HR Status</span></th>
                                                        <th><span>Rejection <br> Reason</span></th>
                                                        <th class="time-width"><span>Date Created</span></th>
                                                        <th class="time-width"><span>Date Updated</span></th>                                                    
                                                    </tr>
                                                </thead>
                                                <tbody data-bind="foreach: applicationHistory">
                                                    <tr class="cursor" data-bind="click: function() { window.open(jobApplicationLink, '_blank') }, attr: { 'data-application-id': applicationId }">
                                                        <td>
                                                            <div class="flex">
                                                                <span data-bind="css: brandIconImage" class="dark full-icon"></span><span data-bind="text: positionName"></span>
                                                            </div>
                                                        </td>
                                                        <td class="time-width"><span data-bind="text: applicationStatus"></span></td>
                                                        <td class="time-width"><span data-bind="text: stepsCompleted"></span> / <span data-bind="text: totalSteps"></span></td>
                                                        <td class="time-width"><span data-bind="text: hrStatus"></span></td>
                                                        <td class="rejection-reason">
                                                            <!-- ko if: idRejectionReason > 0 -->
                                                            <h2 class="rejection-title" data-bind="css: { red: idRejectionReason > 0 && idRejectionReason <= 6, yellow: idRejectionReason > 6 },text: reasonForRejection"></h2>               
                                                            <p class="rejection-info">  By  
                                                            <span class="rejection-info" data-bind="text: rejectedBy"></span>               
                                                            </p>
                                                            <p class="rejection-info" data-bind="text: rejectionTime"></p>               
                                                            <!-- /ko -->
                                                        </td>
                                                        <td class="time-width"><span data-bind="text: dateCreated"></span></td>
                                                        <td class="time-width"><span data-bind="text: dateUpdated"></span></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <!-- /ko -->
                                            <!-- ko if: applicationHistory().length == 0 -->
                                            <div class="form group no-results">
                                                <span class="icon i-samples"></span>
                                                <h2>No Application History Found</h2>
                                            </div>
                                            <!-- /ko -->
                                        </div>
                                    </div>
                                    <div class="form-group form-comment" id="brand-access-notes-section">
                                       <h3 class="form-sub-title no-margin icon i-brand brand-history">Brand Access Notes</h3>
                                    </div>                                    
                                    <div class="form-group">
                                        <!-- ko if: offboardingHistory().length > 0 -->

                                        <div class="w-list-results">
                                            <table class="list-results">
                                                <thead>
                                                    <tr>
                                                        <th><span>Brand Status</span></th>
                                                        <th><span>Offboarding Reason</span></th>
                                                        <th><span>Article Count</span></th>
                                                    </tr>
                                                </thead>
                                                <tbody data-bind="foreach: offboardingHistory">
                                                    <tr>
                                                        <td>
                                                            <div class="flex">
                                                               <span data-bind="css: brandIconImage" class="dark full-icon"></span><span data-bind="text: brandStatus"></span>
                                                            </div>
                                                        </td>
                                                        <td class="rejection-reason">
                                                            <!-- ko if: idRejectionReason > 0 -->

                                                            <h2 class="rejection-title" data-bind="css: { 'hide': idRejectionReason === 0, 'red': rejectionColor =='red' , 'yellow': rejectionColor == 'yellow' }, text: idRejectionReason === 0 ? '' :  offboardingReason"></h2>
                                                            <p class="rejection-info">
                                                                <span class="rejection-info" data-bind="text: 'By ' + offboardingResponsible"></span>  
                                                            </p>
                                                            <p class="rejection-info">
                                                                <span  class="rejection-info" data-bind="text: offboardingTimestamp"></span>             
                                                            </p>
                                                            <!-- /ko -->
                                                        </td>
                                                        <td>
                                                            <div class="flex">
                                                                <span style="flex: none; width: 6rem" data-bind="text: articleCount"></span>
                                                                <a class="btn icon border only-icon i-link" data-bind="attr:{href: articlesLink}" target="_blank"> </a>
                                                            </div>    
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <!-- /ko -->
                                        <!-- ko if: offboardingHistory().length == 0 -->
                                        <div class="form-group no-result">
                                            <span class="icon i-brand"></span>
                                            <h2 class="form-title no-margin">No Brand Access Notes Found</h2>
                                        </div>                                        
                                        <!-- /ko -->                                        
                                    </div>
                                    <div class="form-group form-comment" id="internal-comments-section">
                                       <h3 class="form-sub-title no-margin icon i-notes internal-notes">Internal Comments</h3>
                                    </div>                          
                                    <!-- ko if: internalNotes().length > 0 -->
                                    <div class="form-group form-comment">

                                        <ul data-bind="foreach: internalNotes">
                                            <li>
                                               
                                                <div class="flex space border">
                                                    <div class="flex">
                                                        <span class="user icon i-user" data-bind="text: fullName"></span>
                                                        <span> &nbsp;|&nbsp; </span>
                                                        <span class="details" data-bind="text: dateCreated"> </span>
                                                        <span> &nbsp;|&nbsp; </span>
                                                        <a class="details" data-bind="text: profileName, attr:{href: jobApplicationLink}" target="_blank"> </a>
                                                     
                                                    </div>
                                                    <!-- ko if: $parent.permissions()['job_application_internal_comments'].write || $parent.idLoggedUser() == userId -->
                                                    <button type="button" data-bind="event: { click: $parent.onClickShowDeletePopUp.bind($data, 1) }" class="btn border only-icon icon i-delete"></button>
                                                    <!-- /ko -->
                                                </div>
                                                 <p class="comment" data-bind="text: comment"> </p>
                             
                                            </li>
                                        </ul>

                                    </div>                                          
                                   
                                    <!-- /ko -->
                                    <!-- ko if: internalNotes().length == 0 -->
                                    <div class="form-group">
                                        <div class="form-group no-result">
                                            <span class="icon i-notes"></span>
                                            <h2 class="form-title no-margin">No Internal Comments Found</h2>
                                        </div>
                                    </div>

                                    <!-- /ko -->    
                                     <div class="form-group">
                                        <label for="comments" class="form-label">Add a Comment</label>
                                        <textarea id="comments" style="max-width: none" data-bind="value: internalNote" type="text" class="input-text input-text-comment"></textarea>
                                    </div>
                                    <div class="form-group" style="text-align: right">
                                        <button data-bind="event: { click: onClickAddComment.bind($data, 1) }" class="btn border only-icon icon i-submitted" style="margin-top: -1rem" type="button"><span class="hidden-text">Send</span></button>
                                    </div>                                   
                                </div>

                            </div>
                        
                        </div>
                      
                    </div>
                    
                    <div class="w-form w-form-side">
                    
                        <div class="form-header">
                            <button data-bind="disable: (isStatusResolved() || (isCandidate() && status().id > 3)), event: { click: onClickEdit }" class="btn icon i-edit" type="button">Edit Application</button> 
                        </div>
                        
                        <div class="w-status-bar">
                            <div class="status-left">
                           
                                <!-- ko if: hrStatus() && !isCandidate()-->
                                <span data-bind="css: ((hrStatus().id == '1' ? 'status status-pending icon i-pending' : ((hrStatus().id == '2') ? 'status status-approved icon i-approved' :'status status-rejected icon i-rejected')))">
                                    <span data-bind="text: 'HR ' + hrStatus().name"></span>
                                    <span class="status-info" data-bind="visible: hrStatus() && hrStatus().id > 1">
                                        <span class="status-info">
                                            <span class="status-user" data-bind="text : userUpdatedHrStatus()"></span>
                                            <span class="status-date" data-bind="text : dateUpdatedHrStatus()"></span>
                                        </span>
                                    </span>
                                </span>
                                <!-- /ko -->
                                
                                
                               <!-- ko if: status() -->
                               <span data-bind="css: statusClass()">
                                    <span data-bind="text: 'Application ' + status().name"></span>
                                    <span class="status-info" data-bind="visible: status() && status().id > 1">
                                        <span class="status-info">
                                            <span class="status-user" data-bind="text : userUpdatedStatus()"></span>
                                            <span class="status-date" data-bind="text : dateUpdatedStatus()"></span>
                                        </span>
                                    </span>
                                </span>
                                <!-- /ko -->
                            </div>  
                             
                            <div class="status-right">
                                <span data-bind="css:{ 'is-complete' : stepsCompleted() > 0 && totalSteps() > 0 && stepsCompleted()/totalSteps() == 1 }"><span data-bind="text: stepsCompleted()+'/'+totalSteps()"></span>steps completed</span>
                            </div> 
                              
                        </div>
                        
                        <div class="application-btn" data-bind="visible : !isCandidate()">
                        
                             <!-- ko if: permissions()['job_application_hr_flag'].write && hrStatus() && hrStatus().id == '1'-->
                             <button data-bind="event: { click: onClickShowConfirmPopUp.bind($data, 'HR', 'Approved', 2)}"  class="btn approved"  type="button"> HR approved  </button>
                             <button data-bind="event: { click: onClickShowConfirmPopUp.bind($data, 'HR', 'Rejected', 3)}"  class="btn rejected"  type="button"> HR Rejected </button>
                             <!-- /ko -->
                            
                            <!-- ko if: permissions()['job_application_status'].write && hrStatus() && hrStatus().id == '2' && (status() && status().id < 3) -->
                            <button data-bind="event: { click: onClickShowConfirmPopUp.bind($data, 'Application', 'Approved', '3')}" class="btn approved" type="button">Application Approved</button>
                            <button data-bind="event: { click: onClickShowConfirmPopUp.bind($data, 'Application', 'Rejected', '4')}" class="btn rejected" type="button">Application Rejected</button>
                            <button data-bind="event: { click: onClickShowConfirmPopUp.bind($data, 'Application', 'Canceled', '5') }" class="btn cancel" type="button">Application Canceled</button>
                            <!-- /ko -->
                        
                        </div>

                        <div class="w-form-body sticky" id="external-comments">
                            <div class="form-body full-width ">
                                <strong class="form-sub-title">Chat</strong>
                                <div class="form-group" style="margin-bottom: .5rem;">
                                    <label for="comments" class="form-label">Send A Message</label>
                                    <textarea id="comments" data-bind="value: comment" class="input-text input-text-comment"></textarea>
                                </div>
                                <div class="form-group" style="text-align: right">
                                    <button data-bind="disable: (isStatusResolved() || (isCandidate() && status().id > 3)), event: { click: onClickAddComment.bind($data, 0) }" class="btn border only-icon icon i-submitted" type="button"><span class="hidden-text">Send</span></button>
                                </div>

                                <div class="form-group form-comment">
                                    <ul data-bind="foreach: comments">
                                        <li>
                                            <div class="flex space border">
                                                <div class="flex">
                                                    <!-- ko if: user -->
                                                    <span class="user icon i-user" data-bind="text: user.valnet_user.fullName"></span>
                                                    <!-- /ko -->
                                                    <span> &nbsp;|&nbsp; </span>
                                                    <span class="details" data-bind="text: dateCreated"> </span>                                                
                                                </div>
                                                <!-- ko if: $data.canDelete && $parent.idLoggedUser() == user.id -->
                                                <button type="button" data-bind="disable: ($parent.isStatusResolved() || ($parent.isCandidate() && $parent.status().id > 3)), event: { click: $parent.onClickShowDeletePopUp.bind($data, 0) }" class="btn border only-icon icon i-delete"></button>
                                                <!-- /ko -->
                                            </div>
                                            <p class="comment" data-bind="text: comment"> </p>
                                        
                                        </li>
                                    </ul>
                                </div>
                            </div>
                     
                        </div>
                   
                    </div>
                    
                </div>
                
                <div id="delete-dialog" class="w-lightbox light-theme">
                    <div class="lightbox-content">
                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Deleting Comment</h3>
                                <button type="button"  data-bind="event: { click: onClickHideDeletePopUp }" class="close-button icon i-close-2"></button>
                            </div>
                       
                            <div class="form-body">
                                <div class="form-group">
                                    <p class="form-text">This action is irreversible</p>
                                    <p class="form-text">Are you sure you want to delete the comment:</p>
                                    <span data-bind="text: deletingObject().comment"></span>
                                </div>
                             </div>
                    
                            <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickHideDeletePopUp }" class="btn border only-icon icon">Cancel</button>
                            <button type="button" data-bind="event: { click: onSaveDeleteComment }" class="btn border only-icon icon i-delete">Delete</button>
                        </div>
                        </div>
                    </div> 
                </div>
                
                <div id="confirm-dialog" class="w-lightbox light-theme">
                    <div class="lightbox-content rejection-pop-up">
                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">CONFIRM STATUS UPDATE</h3>
                                <button type="button"  data-bind="event: { click: onClickHideConfirmPopUp }" class="close-button icon i-close-2"></button>
                            </div>
                       
                            <div class="form-body">
                                <div class="form-group">
                                    <span class="form-text" data-bind="html: statusUpdateWarningMessage"></span>
                                </div>

                                <div class="form-group" data-bind="visible: showReasonDropdown">
                                    <label for="reason-dropdown">Rejection Reason:</label>
                                    <select required="required" id="reason-dropdown" data-bind="css: selectedReasonColor,value: selectedReason, options: rejectionReasons, optionsText: 'name', optionsValue: 'id', optionsCaption: 'Select',event: { change: onReasonChange }"></select>
                                </div>
                               
                                 
                             </div>
                    
                            <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickHideConfirmPopUp }" class="btn border">Cancel</button>
                            <button type="button" data-bind="event: { click: onSaveUpdateStatus }" class="btn border">Save</button>
                        </div>
                        </div>
                    </div> 
                </div>               
                `;
    }

    protected initPartial(): void{

    }

    protected getTemplateName(): string{

        return "jobApplication_template";
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;

        return{
             id: ko.observable("")
            , idJobProfile: ko.observable("")
            , positionTitle: ko.observable("")
            , candidateName: ko.observable("")
            , candidateEmail: ko.observable("")
            , userRoles: ko.observable("")
            , country: ko.observable("")
            , candidateProfileLink: ko.observable("")
            , jobProfileViewLink: ko.observable("")
            , jobProfileImageUrl: ko.observable("")
            , userBrands: ko.observableArray([])
            , status : ko.observable("")
            , statusClass : ko.observable("")
            , userUpdatedStatus : ko.observable("")
            , dateUpdatedStatus : ko.observable("")
            , resume: ko.observable("")
            , resumeFile: ko.observable("")
            , coverLetter: ko.observable("")
            , coverLetterFile: ko.observable("")
            , referentialWork: ko.observable("")
            , writtenSample: ko.observable("")
            , writtenSampleFile: ko.observable("")
            , imageSample: ko.observable("")
            , imageSampleFiles: ko.observableArray([])
            , answers: ko.observableArray([])
            , writtenSampleText: ko.observable("") //old
            , isStatusResolved: ko.observable(false)
            , comment: ko.observable("")
            , comments: ko.observableArray([])
            , internalNote: ko.observable("")
            , internalNotes: ko.observableArray([])
            , isCandidate:ko.observable(false)
            , hrStatus : ko.observable()
            , userUpdatedHrStatus : ko.observable('')
            , dateUpdatedHrStatus : ko.observable('')
            , isEditButtonShown: ko.observable(false)
            , deletingObject: ko.observable({'comment':null})
            , isDeletingInternalComment: ko.observable(0)
            , brandIcon: ko.observable("")
            , idLoggedUser: ko.observable("")
            , additionalText:ko.observable(null)
            , totalSteps: ko.observable(0)
            , stepsCompleted: ko.observable(0)
            , stepsDetails: ko.observableArray([])
            , statusUpdateType: ko.observable('')
            , statusUpdateValue: ko.observable('')
            , statusUpdateWarningMessage: ko.observable('')
            , selectedTab: ko.observable('application')
            , permissions: ko.observableArray(this.initPermissions(['job_application_hr_flag', 'job_application_status', 'job_profiles', 'users_list', 'job_application_internal_comments']))
            , rejectionReasons: ko.observableArray([])
            , showReasonDropdown: ko.observable(false)
            , selectedReason: ko.observable('')
            , selectedReasonColor: ko.observable('')
            , applicationHistory: ko.observableArray([])
            , offboardingHistory: ko.observableArray([])
            , onClickEdit: function (data,  event){huit_neuf_this.onClickEdit(data.id());}
            , onClickCancel: function (data, event){huit_neuf_this.onClickCancel();}
            , onClickAddComment: function (value,data, event) {huit_neuf_this.onClickAddComment(value);}
            , onClickShowDeletePopUp: function(value, data, event){huit_neuf_this.onClickShowDeletePopUp(value, data)}
            , onClickHideDeletePopUp: function(data, event){huit_neuf_this.onClickHideDeletePopUp()}
            , onSaveDeleteComment:function (data, event) {huit_neuf_this.onSaveDeleteComment()}
            , onClickDownloadFile: function (path, name, event) {huit_neuf_this.onClickDownloadFile(path, name)}
            , onClickShowConfirmPopUp: function(type, status, value, data, event){huit_neuf_this.onClickShowConfirmPopUp(type, status, value)}
            , onClickHideConfirmPopUp: function(data, event){huit_neuf_this.onClickHideConfirmPopUp()}
            , onSaveUpdateStatus:function (data, event) {huit_neuf_this.onSaveUpdateStatus()}
            , onReasonChange:function (data, event) {huit_neuf_this.onReasonChange(data,event)}
            , getReasonColor:function (data, event) {huit_neuf_this.getReasonColor(data)}
            , onClickTab: function (value, data, event) {huit_neuf_this.onClickTab(value)}
        }
    }

    protected getReasonColor(reason){
        const allReasons = this.getTemplateViewModel().rejectionReasons();
        const reasonObj = allReasons.find(r => r.id === reason);
        return reasonObj ? reasonObj.color : `Unknown Reason (ID: ${reason})`;
    }
    public onClickEdit(id){

        this.caller.editApplication(id);
    }

    public onClickCancel(){

        this.caller.goBack();
    }

    public onClickUpdateStatus(value, data){

        this.caller.updateStatus(value, data)
    }

    public onClickUpdateHrStatus(value, data){

        this.caller.updateHrStatus(value, data)
    }

    public onClickAddComment(value){

        this.caller.addComment(value)
    }

    public onClickShowDeletePopUp(value, data){

        this.getTemplateViewModel().isDeletingInternalComment(value)
        this.getTemplateViewModel().deletingObject(data);
        this.toggleDeleteDialogVisibility();
    }

    public onClickHideDeletePopUp(){

        this.getTemplateViewModel().deletingObject({'comment': null});
        this.toggleDeleteDialogVisibility();
    }

    public toggleDeleteDialogVisibility(){

        document.getElementById('delete-dialog').classList.toggle('is-visible');
    }

    public onSaveDeleteComment(){

        let comment = this.getTemplateViewModel().deletingObject();
        let isInternal = this.getTemplateViewModel().isDeletingInternalComment();
        this.toggleDeleteDialogVisibility();
        this.caller.deleteComment(comment, isInternal);
    }

    public onClickDownloadFile(path, name){

        this.caller.downloadFile(path, name);
    }

    public onClickShowConfirmPopUp(type, status, value){

        let dateTime = new Date().toLocaleString("en-US", {
            timeZone: "America/Toronto",
        });
        let vnApp = this.caller.getVnAppZone().app;
        let warningMessage = '<b>' + type + '</b> status will be updated to <b>' + status + '</b> by <b>' + vnApp.loggedUser.user.valnet_user.fullName + '</b> at <b>' + dateTime + '</b>';
        this.getTemplateViewModel().statusUpdateWarningMessage(warningMessage)
        this.getTemplateViewModel().statusUpdateType(type)
        this.getTemplateViewModel().statusUpdateValue(value)
       
        if(type == 'HR' && value == 3){  
            this.getTemplateViewModel().showReasonDropdown(true);
        } else if( type == 'Application' && value == 4){
            this.getTemplateViewModel().showReasonDropdown(true);
        }else{
            this.getTemplateViewModel().showReasonDropdown(false);
        }

        this.toggleConfirmDialogVisibility();
    }

    public onClickHideConfirmPopUp(){

        this.resetConfirmDialogData();
        this.toggleConfirmDialogVisibility();
    }

    public toggleConfirmDialogVisibility(){

        document.getElementById('confirm-dialog').classList.toggle('is-visible');
    }

    public resetConfirmDialogData(){

        this.getTemplateViewModel().statusUpdateWarningMessage('');
        this.getTemplateViewModel().statusUpdateType('');
        this.getTemplateViewModel().statusUpdateValue('');
    }

    public onSaveUpdateStatus(){


        let reason = this.getTemplateViewModel().selectedReason();

         if (this.getTemplateViewModel().showReasonDropdown()) {
            if(!reason) {
                alert("Please select a reason.");
                return;
            }
        }

        let type = this.getTemplateViewModel().statusUpdateType();
        let value = this.getTemplateViewModel().statusUpdateValue();

        if(type == 'HR'){
            this.caller.updateHrStatus(value)
        }else{
            this.caller.updateStatus(value)
        }

        this.resetConfirmDialogData();
        this.toggleConfirmDialogVisibility();
    }

    onReasonChange = (data: any, event: any) => {
        const selectedId = parseInt(event.target.value);
        this.getTemplateViewModel().selectedReasonColor(this.getReasonColor(selectedId));
        this.getTemplateViewModel().selectedReason(selectedId);
    }

    public onClickTab(value){

        this.getTemplateViewModel().selectedTab(value)
    }

    public setId(id): void{

        this.getTemplateViewModel().id(id);
    }

    public setIdLoggedUser(idLoggedUser): void{

        this.getTemplateViewModel().idLoggedUser(idLoggedUser);
    }

    public setPositionTitle(title): void{

        this.getTemplateViewModel().positionTitle(title);
    }

    public setCandidateName(name): void{

        this.getTemplateViewModel().candidateName(name);
    }

    public setCandidateEmail(email): void{

        this.getTemplateViewModel().candidateEmail(email);
    }

    public setUserRoles(userRoles) {

        this.getTemplateViewModel().userRoles(userRoles);
    }

    public setCountry(country) {

        this.getTemplateViewModel().country(country);
    }

    public setCandidateProfileLink(link) {

        this.getTemplateViewModel().candidateProfileLink(link);
    }

    public setJobProfileViewLink(jobProfileViewLink) {

        this.getTemplateViewModel().jobProfileViewLink(jobProfileViewLink);
    }

    public setJobProfileImageUrl(jobProfileImageUrl) {

        this.getTemplateViewModel().jobProfileImageUrl(jobProfileImageUrl);
    }

    public setUserBrands(userBrands) {

        this.getTemplateViewModel().userBrands(userBrands);
    }

    public setStatus(name): void{

        this.getTemplateViewModel().status(name);
    }

    public setUserUpdatedStatus(name): void{

        this.getTemplateViewModel().userUpdatedStatus(name);
    }
    public setRejectionReasons(rejectionReasons){

        this.getTemplateViewModel().rejectionReasons(rejectionReasons);
    }
    public setDateUpdatedStatus(date): void{

        this.getTemplateViewModel().dateUpdatedStatus(date);
    }

    public setStatusClass(name): void{

        this.getTemplateViewModel().statusClass(name)
    }

    public setResume(resume): void{

        this.getTemplateViewModel().resume(resume)
    }

    public setResumeFile(file): void{

        this.getTemplateViewModel().resumeFile(file)
    }

    public setCoverLetter(coverLetter): void{

        this.getTemplateViewModel().coverLetter(coverLetter)
    }

    public setCoverLetterFile(file): void{

        this.getTemplateViewModel().coverLetterFile(file)
    }

    public setReferentialWork(referentialWork): void{

        this.getTemplateViewModel().referentialWork(referentialWork)
    }

    public setWrittenSample(writtenSample): void{

        this.getTemplateViewModel().writtenSample(writtenSample)
    }

    public setWrittenSampleFile(file): void{

        this.getTemplateViewModel().writtenSampleFile(file)
    }

    public setImageSample(imageSample): void{

        this.getTemplateViewModel().imageSample(imageSample)
    }

    public setImageSampleFiles(files): void{

        this.getTemplateViewModel().imageSampleFiles(files)
    }

    public setAnswers(answers): void{

        this.getTemplateViewModel().answers(answers)
    }

    public setWrittenSampleText(text): void{

        this.getTemplateViewModel().writtenSampleText(text)
    }

    public setStatusResolved(isStatusResolved): void{

        this.getTemplateViewModel().isStatusResolved(isStatusResolved);
    }

    public setComments(comments): void{

        this.getTemplateViewModel().comments(comments)
    }

    public setInternalNotes(notes): void{

        this.getTemplateViewModel().internalNotes(notes)
    }

    public setApplicationHistory(applicationHistory): void{

        this.getTemplateViewModel().applicationHistory(applicationHistory)
    }
    public setOffboardingHistory(offboardingHistory): void{

        this.getTemplateViewModel().offboardingHistory(offboardingHistory)
    }
    public setHrStatus(hrStatus): void{

        this.getTemplateViewModel().hrStatus(hrStatus)
    }

    public setUserUpdatedHrStatus(user): void{

        this.getTemplateViewModel().userUpdatedHrStatus(user)
    }

    public setDateUpdatedHrStatus(date): void{

        this.getTemplateViewModel().dateUpdatedHrStatus(date)
    }

    public setIsCandidate(isCandidate){

        this.getTemplateViewModel().isCandidate(isCandidate)
    }

    public setIsEditButtonShown(isEditButtonShown:boolean){

        this.getTemplateViewModel().isEditButtonShown(isEditButtonShown);
    }

    public setFileIcon(type, name){

        document.getElementById(type).classList.add(name);
    }

    public setBrandIcon(brandIcon): void{

        this.getTemplateViewModel().brandIcon(brandIcon);

    }

    public setPermissions(permissions): void{

        this.getTemplateViewModel().permissions(permissions);
    }

    public setAdditionalText(additionalText): void{

        this.getTemplateViewModel().additionalText(additionalText);

    }

    public setStepsDetails(details) {

        this.getTemplateViewModel().stepsDetails(details);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/jobApplicationsView_template.ts